import styled from '@emotion/styled';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Typography,
} from '@mui/material';
import { UIColors } from '../../constants/UIConstants';
import { pxToRem } from '../../utils/getFontValue';

// Custom styled components for Login Page and related forms

const LoginCard = styled(Box)({
  width: '100%',
  maxWidth: pxToRem(420),
  padding: `${pxToRem(40)} ${pxToRem(36)}`,
  borderRadius: pxToRem(12),
  border: `1px solid ${UIColors.neutrals.grey40}`,
  backgroundColor: UIColors.globalBG.white,
  boxShadow: '0 4px 24px rgba(38, 38, 109, 0.08)',
});

// Google Sign In Button
const GoogleSignInButton = styled(Button)({
  width: '100%',
  minHeight: pxToRem(48),
  padding: `${pxToRem(10)} ${pxToRem(16)}`,
  border: `1px solid ${UIColors.neutrals.grey40}`,
  borderRadius: pxToRem(8),
  color: UIColors.textColors.grey90,
  backgroundColor: UIColors.globalBG.white,
  fontWeight: 600,
  fontSize: pxToRem(16),
  textTransform: 'none',
  justifyContent: 'center',
  gap: pxToRem(12),
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
  '&.MuiButton-outlined': {
    border: `1px solid ${UIColors.neutrals.grey40}`,
  },
  '&:hover': {
    border: `1px solid ${UIColors.neutrals.grey60}`,
    backgroundColor: UIColors.neutrals.grey10,
    color: UIColors.textColors.grey90,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
  },
  '&.MuiButton-outlined:hover': {
    border: `1px solid ${UIColors.neutrals.grey60}`,
  },
  '&.Mui-disabled': {
    color: UIColors.textColors.grey80,
    border: `1px solid ${UIColors.neutrals.grey40}`,
    backgroundColor: UIColors.globalBG.white,
    boxShadow: 'none',
  },
});
// Box inside the button to hold the google logo or loader
const StyledGoogleBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: pxToRem(24),
  width: pxToRem(24),
  flexShrink: 0,
});
// Loader to replace google image on click of the button
const GoogleLoader = styled(CircularProgress)({
  color: UIColors.primary.navyBlue,
});
// Divider on the login page
const StyledDivider = styled(Divider)((props) => ({
  ':before, :after': {
    borderColor: UIColors.primary.darkRed,
    borderWidth: pxToRem(4),
  },
}));
// Loader to replace the texts on all the other buttons
const LoginLoader = styled(CircularProgress)((props) => ({
  color: UIColors.textColors.white,
}));
// Styled button for login forms
const StyledFormButton = styled(Button)((props) => ({
  backgroundColor: UIColors.primary.navyBlue,
  minHeight: pxToRem(44),
  fontSize: pxToRem(18),
  '&:hover': {
    backgroundColor: UIColors.primary.navyBlue,
    boxShadow: '10',
    cursor: 'pointer',
  },
  '&.Mui-disabled': {
    color: UIColors.textColors.white,
    backgroundColor: UIColors.primary.navyBlue,
  },
}));
// Form heading container
const StyledFormHeadingContainer = styled(Box)((props) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));
// Form primary heading
const StyledFormPrimaryHeading = styled(Typography)((props) => ({
  color: UIColors.textColors.navyBlue,
  minHeight: pxToRem(34),
  fontWeight: 'bolder',
  fontSize: pxToRem(18),
  textTransform: 'uppercase',
}));
// Form secondary heading
const StyledFormSecondaryHeading = styled(Typography)((props) => ({
  color: UIColors.textColors.grey80,
  minHeight: pxToRem(20),
  fontSize: pxToRem(18),
}));
// Styled container box for First Time Login and ForgotPW Form
const StyledBoxFormContainer = styled(Box)((props) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
  maxWidth: pxToRem(387),
  width: '100%',
  height: pxToRem(432),
}));

const StlyedBoxBackButtonContainer = styled(Box)((props) => ({
  width: '100%',
  paddingLeft: pxToRem(120),
}));
const StyledFormPage = styled(Box)((props) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));
const StyledFormTextLink = styled(Typography)((props) => ({
  color: UIColors.secondary.brightBlue,
  fontSize: 'small',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}));
export {
  GoogleSignInButton,
  LoginCard,
  StyledGoogleBox,
  GoogleLoader,
  StyledDivider,
  LoginLoader,
  StyledFormButton,
  StyledFormHeadingContainer,
  StyledFormPrimaryHeading,
  StyledFormSecondaryHeading,
  StyledBoxFormContainer,
  StlyedBoxBackButtonContainer,
  StyledFormPage,
  StyledFormTextLink,
};
